import React from 'react'
import { useState } from 'react'
import { useLocalState } from '../../../../shared/UseLocalState'
import { ExamDto } from '../../../../api'
import { actualShowState } from '../../../../state/ActualShow.state'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { registrationState } from '../Registration.state'

export const ExamsScreen = () => { 
  /* STATE */

    const exams = useLocalState<ExamDto[]>(actualShowState.actualShowExams$, actualShowState.actualShowExams$.value)
    const selectedExams = useLocalState<ExamDto[]>(registrationState.selectedExams$, registrationState.selectedExams$.value)
    const [filter, setFilter] = useState('')

    const filteredExams = exams
      ?.filter((exam) => {
        if (!filter) return true
        const q = filter.toLowerCase()
        return (
            exam?.gweType?.toLowerCase().includes(q) ||
            exam?.breedOnly?.toLowerCase().includes(q) ||
            exam?.name?.toLowerCase().includes(q) ||
            exam?.description?.toLowerCase().includes(q)
        )
      })
      ?.slice()
      .sort((a, b) => {
        const aSelected = selectedExams.some((se) => se.id === a?.id) ? 0 : 1
        const bSelected = selectedExams.some((se) => se.id === b?.id) ? 0 : 1
        if (aSelected !== bSelected) return aSelected - bSelected
        return (a?.sort ?? 0) - (b?.sort ?? 0)
      })

  /* TEMPLATE */
    /* no select
              isDataSelectable={() => false}
          rowClassName={() => 'p-disabled'}

    */
    return (
    <div>
      <div>
        <h2>Verfügbare Prüfungen. Für Storno Prüfung abwählen</h2>
        <div style={{ marginBottom: '1rem' }}>
          <InputText
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder='Prüfungen Filtern ...'
            style={{ width: '100%' }}
          />
        </div>
        <DataTable
          showSelectAll={false}
          showHeaders={true}
          value={filteredExams}
          selectionMode='multiple'
          selection={selectedExams}
          onSelectionChange={(e) => registrationState.selectedExams$.next(e.value)}
        >
          <Column selectionMode='multiple' bodyStyle={{ width: '3rem' }} />
          <Column
            header='Nr'
            field='no'
            body={(exam: ExamDto) => exam?.no}
          />
          <Column
            header='GWE Typ'
            field='gwetyp'
            body={(exam: ExamDto) => (
              <div>
                <b>{exam?.gweType}</b>
              </div>
            )}
          />

          <Column
            header='Name'
            field='name'
            body={(exam: ExamDto) => (
              <div>
                <b>{exam?.name}{exam?.type ? ` (${exam.type})` : ''}</b>
                <p>{exam?.description}</p>
              </div>
            )}
          />
        </DataTable>
      </div>
    </div>
  )
}
